import {EPaymentInstrument, IUseDigitalWallets, TPaymentInstrument} from "./wallet-types";
import {PROVIDER_NAMES} from "../../../variables/digital-wallets";
import store from "../../../state/store";

export const getProviderName: IUseDigitalWallets['getProviderName'] = (providerName, type = 'full', ): string => {
  const provider = PROVIDER_NAMES?.[providerName];

  return provider ? provider[type] : '';
};

export const checkIsDigitalWallet = (m: TPaymentInstrument) => {
  return m === EPaymentInstrument.GooglePay || m === EPaymentInstrument.ApplePay;
};

export const getWalletCurrencyLimits = (currency: string) => {
  const { paymentInstrument, cardTokenizationOptions } = store.getState().payInfo.digitalWallets;
  if (!checkIsDigitalWallet(paymentInstrument)) return null;

  return cardTokenizationOptions?.[paymentInstrument]?.currency_list?.[currency] ?? null;
};

const PAGE_ORIGIN_STORAGE_KEY = 'page_origin';

export const getPageOrigin = (): string => {
  try {
    const cached = sessionStorage.getItem(PAGE_ORIGIN_STORAGE_KEY);
    if (cached) return cached;
  } catch {}

  const origin = window?.CASHIER_CONFIG?.refererDomain || window.location.host;

  try {
    sessionStorage.setItem(PAGE_ORIGIN_STORAGE_KEY, origin);
  } catch {}

  return origin;
};
